<template>
  <v-chip
    :color="getStatusColor(status.name)"
    text-color="white"
    style="width: 100%; max-width: 100px"
    label
  >
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  name: 'ProductStatus',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatusColor(status) {
      let color = '#2281C9'

      switch (status) {
        case 'AVAILABLE':
          color = '#9ccc65'
          break

        case 'UNAVAILABLE':
          color = '#ef5350'
          break

        default:
          color = '#2281C9'
      }

      return color
    },
  },
}
</script>
